module.exports = __webpack_public_path__ + "img/digitalis_farm_pop_up.f07152bd.png";